export const archivo_item = [
    {
        "archivo_item_nombre" : "Arts. 69 Ley de Transparencia (48 Rubros)",
        "archivo_item_url" : "Rubros"
    },
    {
        "archivo_item_nombre" : "48 Rubros",
        "archivo_item_url" : "Rubros"
    },
    {
        "archivo_item_nombre" : "48 Rubros",
        "archivo_item_url" : "Rubros"
    },
    {
        "archivo_item_nombre" : "48 Rubros",
        "archivo_item_url" : "Rubros"
    }
]